<template>
  <div class="warpper">
    <!-- 病历信息 -->
    <div class="line">
      <span class="line-title">病历信息</span>
      <!-- 病历详情 -->
      <caseDetail />
    </div>
    <!-- 处方单 -->
    <div class="line">
      <span class="line-title">处方笺</span>
      <!-- 处方详情 -->
      <div class="prescription-html">
        <span v-html="prescriptionHtml"></span>
      </div>
    </div>
    <!-- 审核进度 -->
    <div class="line">
      <span class="line-title">审核进度</span>
      <div class="line-approval">
        <el-timeline>
          <el-timeline-item
            :color="status >= 11800 ? '#0bbd87' : ''"
            size="large"
          >
            处方创建
          </el-timeline-item>
          <!-- <el-timeline-item
            :color="prescriptionStatus || status >= 11802 ? '#0bbd87' : ''"
            size="large"
          >
            <p>智能审方</p>
            <template v-if="status >= 11802">
              <div v-if="prescriptionStatus" class="auditTag sucsess">
                通过
              </div>
              <div v-else class="auditTag waring">
                未通过
              </div>
            </template>
          </el-timeline-item> -->
          <el-timeline-item
            v-if="!prescriptionStatus"
            :color="status >= 11804 ? '#0bbd87' : ''"
            size="large"
          >
            药师初审
            <div v-if="![11804,11805,11808,11806,11809,11807].includes(status)" class="auditTag sucsess">待审核</div>
            <div v-else class="auditTag">
              <div v-if="status == 11808" class="false">未通过</div>
              <div v-else class="sucsess">审核通过</div>
              <div style="margin-top: 6px;">审核意见：{{ recipe.pharmacistCause }}</div>
            </div>
          </el-timeline-item>
          <el-timeline-item
            v-if="!prescriptionStatus"
            :color="status >= 11806 ? '#0bbd87' : ''"
            size="large"
          >
            药师复审
            <p v-if="![11806,11809,11807].includes(status)" class="auditTag sucsess">待审核</p>
            <div v-else class="auditTag">
              <div v-if="status == 11809" class="false">未通过</div>
              <div v-else class="sucsess">审核通过</div>
              <div style="margin-top: 6px;">审核意见：{{ recipe.rePharmacistCause }}</div>
            </div>
          </el-timeline-item>
          <el-timeline-item
            :color="prescriptionStatus || status == 11807 ? '#0bbd87' : ''"
            size="large"
          >
            处方生成
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="footer">
      <el-button
        v-if="status == 11801"
        type="primary"
        class="signature"
        @click="signature()"
        >签名
      </el-button>
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>
<script>
import { getPrescriptionForm, getRecipe } from "@/api/index.js";
import { prescriptionSign } from "@/api/doctor";
import caseDetail from "@/components/case/detaiInfo";
import prescriptionPdf from "@/components/prescriptionPdf";

export default {
  name: "PerscriptionDetail",
  components: { prescriptionPdf, caseDetail },
  data() {
    return {
      activities: [
        {
          content: "支持使用图标",
          timestamp: "2018-04-12 20:46",
          size: "large",
          type: "success",
        },
        {
          content: "支持自定义颜色",
          timestamp: "2018-04-03 20:46",
          color: "#0bbd87",
          size: "large",
        },
        {
          content: "支持自定义尺寸",
          timestamp: "2018-04-03 20:46",
          size: "large",
        },
      ],
      prescriptionId: "",
      detailInfo: {},
      prescriptionHtml: "",
      status: 0,
      recipe:{}
    };
  },
  computed:{
    prescriptionStatus(){
      return this.status != 11800 && this.status != 11801 && this.status == 11810 
    }
  },
  created() {
    this.readyList();
    this.getRecipe();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    /**
     * 获取数据--处方信息
     */
    async readyList() {
      try {
        const params = {
          recipeId: this.$route.query.prescriptionId,
        };
        const res = await getPrescriptionForm(params);
        if (res.code == 1) {
          this.prescriptionHtml = res.data;
        }
      } catch (error) {}
    },
    async getRecipe() {
      const params = {
        recipeId: this.$route.query.prescriptionId,
      };
      const res = await getRecipe(params);
      if (res.code == 1) {
        this.recipe = res.data.recipe;
        this.status = res.data.recipe.status;
      }
    },
    /*
     *签名
     */
    async signature() {
      const params = {
        recipeId: this.$route.query.prescriptionId,
      };
      const res = await prescriptionSign(params);
      if (res.code == 1) {
        // this.$message.success("已提交签名任务至信手书，请在信手书完成下一步签名操作");
        window.location.href = res.data;
      }else{
        this.$message.warning("签名失败");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.warpper {
  width: 930px;
  background: #ffffff;
  margin: 0 auto;
  padding: 20px;

  .line {
    margin: 20px 0;
    padding-left: 15px;
    font-size: 18px;
    color: #333333;
    font-weight: 600;
    line-height: 18px;
    &-title {
      padding-left: 5px;
      border-left: 5px solid #fc701a;
    }
    &-approval {
      margin-top: 15px;
    }
  }
  .footer {
    float: right;
    height: 50px;
    button {
      width: 100px;
    }
  }
  .auditTag{
    margin-top: 10px;
    font-size: 13px;
  }

  .sucsess{
    color: #409eff;
  }
  .waring{
    color: #e6a23c;
  }
  .false{
    color: #f56c6c;
  }
}
</style>